import type {
  ColorFieldRaw,
  ColorFieldStyle,
  ColorFieldConstant,
  ShadowFieldStyle,
  SpacingAllField,
  SpacingTwoSidesField,
  SpacingSeparateSidesField,
  SizeFieldConstant,
  SizeFieldRaw,
  SizeFieldStyle,
  RadiusSeparateCornersField,
} from '../../api'

export type ColorField = ColorFieldRaw | ColorFieldStyle | ColorFieldConstant

export type SpacingField = SpacingAllField | SpacingTwoSidesField | SpacingSeparateSidesField

export type SizeField = SizeFieldRaw | SizeFieldStyle | SizeFieldConstant

export type RadiusField = SizeField | RadiusSeparateCornersField

export type ShadowField = ShadowFieldStyle

// Special shadow key meaning "no shadow". The picker writes this when the user
// picks "None"; getShadowStyleData turns it into no shadow.
export const SHADOW_NONE_KEY = '__none__'

export type GradientStop = {
  color: ColorField
  position: number
}

export type LinearGradientField = {
  type: 'linear_gradient'
  angle: number
  stops: GradientStop[]
}

export type GradientField = LinearGradientField
